import {useGetDirectorInfo} from '@/api/Director/useGetDirectorInfo';
import {useProfiles} from '@/api/User/useProfiles';
import {roleType} from '@/constants/constants';
import {InviteView} from '@/pages/Coach/CoachInvite/Invite.view';
import {useMemo} from 'react';
import {useParams} from 'react-router-dom';
import {toast} from 'react-toastify';

export const DirectorInvite = () => {
  const {teamId} = useParams();
  const {currentProfile} = useProfiles();
  const {data: directorInfo, isLoading} = useGetDirectorInfo(currentProfile?._id);

  const teamInfo = useMemo(
    () => directorInfo?.teams.find((team) => team._id === teamId),
    [teamId, directorInfo?.teams]
  );
  const inviteLink = `${window.location.origin}/team-onboarding?teamId=${teamId}&role=${roleType.player}&locationId=${teamInfo?.siteId}`;

  const copyInviteLink = () => {
    navigator.clipboard.writeText(inviteLink);
    toast.success('Invite link copied to clipboard');
  };

  const handleInviteLinkShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Player invite link!',
          url: inviteLink,
        });
      } catch (error) {
        copyInviteLink();
      }
    } else {
      copyInviteLink();
    }
  };

  return <InviteView isLoading={isLoading} inviteLink={inviteLink} handleInviteLinkShare={handleInviteLinkShare} />;
};
